import { useState, useEffect } from "react";
import { getStreetById } from "../api/streets/streetRequest";

export const useStreetDetails = (streetId) => {
  const [streetDetails, setStreetDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!streetId) return;

    const fetchStreetDetails = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getStreetById(streetId);
        setStreetDetails(data);
      } catch (err) {
        setError(
          err.response?.data?.message || "Failed to fetch street details"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchStreetDetails();
  }, [streetId]);

  return { streetDetails, loading, error };
};
